import styled from 'styled-components'
import { ModalBody } from '@rodeo-dev/legos'

const DialogPdfPreviewBody = styled(ModalBody)`
  min-height: 75vh;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;

  & iframe {
    border: 0;
    box-sizing: content-box;
    overflow: hidden;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
  }
`

export default DialogPdfPreviewBody
